import {Route as RouteType} from '../types'
import Middleware from './Middleware'
import SuspensedView from './SuspensedView'

type RouteProps = {
  route: RouteType
}

export default function Route({route}: RouteProps) {
  return (
    <SuspensedView>
      <Middleware route={route} />
    </SuspensedView>
  )
}
